<div class="row">
    <div class="col-md-12 top">
        <span>How would you like to get help?</span>
    </div>
    <div class="col-md-12 second pt-4">
        <span>Choose the option that is most convenient for you.</span>
    </div>
    <div class="col-md-8 body">
        <div class="row">
            <div class="col-md-4 phoneEmail">
                <i class="fa fa-phone"></i>
                <h5 class="pt-3">Phone</h5>
                <a href="tel:+91-9880858744">+91-9880858744</a>
                <p>Phone support is currently unavailable.</p>
                <em>See phone support hours ></em>
            </div>
            <div class="col-md-4 phoneEmail">
                <i class="fa fa-envelope"></i>
                <h5 class="pt-3">Email</h5>
                <a href="mailto:support@pawsnme.com">support@pawsnme.com</a>
                <p>Ask a question and we'll reply by email.</p>
            </div>
        </div>
    </div>
</div>